import { Spacing } from "@bonusx-global/bx-design-system";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import { headerHeight } from "../../../../../R";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type {
  IRouteWrapperGetVariant,
  IRouteWrapperVariant,
} from "../../../../../types/layout/route-wrapper-variant.interface";

export class FullScreenWithHeaderAndCloseModalRouteWrapperVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return false;
  }
  get headerAvailable(): boolean {
    return true;
  }
  get bottomNavigationAvailable(): boolean {
    return false;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {
      contentLayoutStyles: {
        mobile: {
          height: `calc(100vh - ${headerHeight})`,
          paddingBottom: `${Spacing["2500"]} !important`,
        },
        desktop: {
          maxWidth: "96rem !important",
        },
        desktopOuterContainer: {
          padding: `${Spacing["2500"]} ${Spacing["2500"]} ${Spacing["4000"]} ${Spacing["2500"]} !important`,
        },
      },
    };
  }

  get titleAvailable(): boolean {
    return true;
  }

  getVariantHeaderSettings({
    title,
    defaultCloseButtonModal: closeButtonModal,
    progressBar,
    progressBarPercentage,
  }: IRouteWrapperGetVariant): IHeaderV2Store {
    return {
      layoutStore: {
        closeButton: {
          modal: closeButtonModal,
        },
        showLogo: false,
        showLogoOnMobile: false,
        forceLogoExtended: false,
      },
      contentStore: {
        title,
      },
      progressStore: {
        progressBar: progressBar,
        progressBarPercentage: progressBarPercentage ?? 0,
      },
    };
  }
}
